/**
 * @fileoverview Dashboard index route configuration
 * Renders the main dashboard overview page with key metrics and summaries
 */

// Library imports
import { createFileRoute, Navigate } from "@tanstack/react-router";

// Page components
import { useAuth } from "@/providers/auth.provider";
import { AppErrorBoundary } from "@/components/shared/app-error-boundary";

/**
 * /dashboard is the client workspace now (ops split): everyone workspace-shaped lands on
 * TaxPulse; operators' Command Center lives at /ops.
 */
function DashboardIndex() {
  const { claims } = useAuth();

  // Claims not resolved yet: render nothing rather than flashing the wrong home.
  if (!claims) {
    return null;
  }

  if (claims.managementAccess) {
    return <Navigate to="/ops" replace />;
  }

  return <Navigate to="/dashboard/taxpulse" replace />;
}

/**
 * Route configuration for the main dashboard page
 * Uses TanStack Router's file-based routing system
 */
export const Route = createFileRoute("/(app)/dashboard/")({
  component: DashboardIndex,
  errorComponent: AppErrorBoundary,
});
